(() => {
  const selector = '[data-lunna-buy-now]';

  document.addEventListener('click', async (event) => {
    const button = event.target.closest(selector);
    if (!button || button.disabled) return;

    const productForm = button.closest('product-form');
    const form = productForm?.querySelector('form');
    if (!form) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(routes.cart_add_url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });

      const result = await response.json();

      if (!response.ok || result.status) {
        throw new Error(result.description || result.message || 'Unable to add this item to cart.');
      }

      window.location.assign('/checkout');
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.removeAttribute('aria-busy');

      const errorWrapper = productForm.querySelector('.product-form__error-message-wrapper');
      const errorMessage = productForm.querySelector('.product-form__error-message');

      if (errorWrapper && errorMessage) {
        errorMessage.textContent = error.message || 'Unable to start checkout. Please try again.';
        errorWrapper.hidden = false;
      }
    }
  });
})();
